module.exports = __webpack_public_path__ + "static/media/galerija_2019 (23).e07527a2.jpg";